import axios from 'axios'
import React, { useEffect, useState } from 'react'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../redux/user/user.selectors'
import { removeCurrentUser } from '../../redux/user/user.action'

import ButtonLink from '../../components/ButtonLink'
import FetchLoading from '../../components/FetchLoading'
import Layout from '../../layout'
import { TabelKupon } from './components'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ROLE_PRODUCT_READ_ONLY } from '../../utils'

const PogramKupon = () => {
  const currentUser = useSelector(selectCurrentUser)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [coupons, setCoupons] = useState(null)

  const user_read_only = ROLE_PRODUCT_READ_ONLY.find(
    (role) => role === currentUser.user.role
  )

  useEffect(() => {
    axios({
      method: 'get',
      url: '/coupon',
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then(({ data }) => {
        setCoupons(data)
      })
      .catch((error) => {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error')
        }
        if (error.response.status === 403) {
          message.error('403 Forbidden')
        }
      })
  }, [currentUser.token, dispatch, navigate])

  console.log(coupons)

  return (
    <Layout title="Kupon">
      {user_read_only ? null : (
        <ButtonLink
          urlRoute="/program/kupon/kupon-tambah"
          title="Tambah Kupon"
        />
      )}
      <FetchLoading data={coupons}>
        <TabelKupon
          coupons={coupons}
          user_read_only={user_read_only}></TabelKupon>
      </FetchLoading>
    </Layout>
  )
}

export default PogramKupon
